import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=af22a254&scoped=true"
import script from "./relationship.vue?vue&type=script&lang=js"
export * from "./relationship.vue?vue&type=script&lang=js"
import style0 from "./relationship.vue?vue&type=style&index=0&id=af22a254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22a254",
  null
  
)

export default component.exports